module.exports = __webpack_public_path__ + "ota-facility-icon.0f71fcc8271a0034f033.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ota-facility-icon/fonts/ota-facility-icon.eot?bot94j
// module id = 316
// module chunks = 24